import { makeStyles } from '@material-ui/core';
import React from 'react';

export interface BackgroundProps {
  children: any;
}

// Solid backdrop on the kit's deepest brand green: Jupiter "Green Deeper".
const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'var(--jupiter-900)',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
}));

export default function Background({ children }: BackgroundProps) {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
}
